<template>
  <div>
    <Row>
      <Form ref="queryAttendanceManagerForm" :model="query" :label-width="100"  label-position="right" inline class="index-query-form">
        <Form-item :label="this.$t('ipms.attendance-manager.nackname.label')" prop="nackname">
          <Select v-model="query.userId" clearable filterable :placeholder="$t('ipms.attendance-manager.nackname.holder')">
            <Option v-for="item in attManagerTree" :value="item.userId" :key="item.userId">{{ item.nickName }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="this.$t('ipms.attendance-manager.attendanceGroup.label')" prop="attendanceGroup">
          <Select v-model="query.attendanceGroup" clearable filterable :placeholder="$t('ipms.attendance-manager.attendanceGroup.holder')" style="width: 120px">
            <Option v-for="item in dict.attendanceGroup" :value="item.dictKey" :key="item.dictValue">{{ item.dictValue }}</Option>
          </Select>
        </Form-item>
        <Form-item :label-width="0">
            <span @click="handleSearch" style="margin: 0 10px;"><Button type="primary" >{{$t('searchText')}}</Button></span>
            <Button @click="resetSearchForm" type="default" >{{$t('resetText')}}</Button>
        </Form-item>
        <Button @click="openAttendanceManagerDrawer()" type="primary" style="margin-right: 10px;float:right" >{{$t('newText')}}</Button>
      </Form>
    </Row>
    <Row v-loading="page.loading" class="margin-top-10  searchable-table-con1"  style="width:100%;">
      <Table ref="attendanceManagerTable" :columns="columns" stripe border :data="page.data" @on-sort-change="handlePageSortChange"></Table>
      <Row v-if="page.total>0" type="flex" justify="space-between" align="middle" >
        <!-- <div>
          <Select v-model="batchOperate.action" placeholder="请选择" style="width:120px;margin-right: 10px;">
            <Option v-for="item in batchOperate.options" :key="item.value" :label="item.label" :value="item.value"></Option>
          </Select>
          <Button type="primary" :disabled="this.batchOperate.action=='' || $refs.attendanceManagerTable.getSelection().length == 0" :loading="batchOperate.submiting" @click="handleBatchOperate">{{ batchOperate.submiting ? '提交中 ...' : '确 定' }}</Button>
        </div> -->
        <Page :current="page.current" :total="page.total"  :page-size="page.size" @on-change="handlePageChange" show-elevator show-total style="padding: 10px;"></Page>
      </Row>
    </Row>
    <el-drawer ref="attendanceManagerDrawer" :title="this.$t('drawer.title')[attendanceManagerDrawer.type]" :visible.sync="attendanceManagerDrawer.visible" direction="rtl" size="40%" custom-class="right-drawer">
      <div class="right-drawer__content">
        <attendanceManager-form ref="attendanceManagerForm"/>
        <div class="right-drawer__footer" v-if="attendanceManagerDrawer.type!='detail'">
          <Button type="primary" @click="handleSubmit()" :loading="attendanceManagerDrawer.submiting">{{ attendanceManagerDrawer.submiting ? '提交中 ...' : '保 存' }}</Button>
          <Button @click="attendanceManagerDrawer.visible=false">取 消</Button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script type="text/jsx">
import dict from '@/components/dict'
import Vue from 'vue';

import api from '@/api'
import mixin from '@/libs/mixins/Index'

import AttendanceManagerForm from '@/views/ipms/attendance-manager/components/Form.vue';
Vue.component('attendanceManager-form', AttendanceManagerForm);

export default {
  name: 'aip-ipms-attendanceManager-index',
  mixins:[mixin],
  dictParams: ['attendanceGroup'],
    components: {
      'dict-tag': dict
    },
  data () {
    return {

      attManagerTree:[],
      query:{
          name:'',
          attendanceGroup: '',
      },
      page:{
         size: 10,
         current: 1,
         total: 0,
         sort: "id_desc",
         loading:false,
         data:[]
      },
      options1:[],
      attendanceManagerDrawer:{
        action:'add',
        visible: false,
        submiting:false
      },
      batchOperate:{
        action:'',
        submiting:false,
        options:[
          {value:'handleBatchRemove',label:'批量删除'}
        ]
      }
    }
  },
  created () {
    this.treeSelect();
  },
  methods: {
    treeSelect(){
      api.ipms.AttendanceManager.treeselect()
      .then(data=>{
        this.attManagerTree=data
         console.log(data);
      }).catch(error=> console.log(error))
    },
    handleSearch(){
      this.page.loading = true;
      api.ipms.AttendanceManager.query(this.query,this.page)
        .then(data=>{
          console.log(data);
            this.page =  Object.assign(this.page,data);
            this.page.loading = false;
        }).catch(error=> this.page.loading = false)
    },
    remoteMethod () {
      getStoreAreaInfo().then((res) => {
          this.options1 = res;
      })
    },
    openAttendanceManagerDrawer(attendanceManager){
      this.attendanceManagerDrawer.visible = true
      this.attendanceManagerDrawer.type = attendanceManager ? attendanceManager.type : 'add'
      this.$nextTick(()=>{
          if(attendanceManager){
              this.$refs['attendanceManagerForm'].getAttendanceManager(attendanceManager.id,attendanceManager.type)
          }else{
            this.$refs['attendanceManagerForm'].handleReset()
          }
      })
    },
    handleSubmit(){
        this.attendanceManagerDrawer.submiting = true;
        this.$refs.attendanceManagerForm.handleSubmit(
          data=>{
            this.attendanceManagerDrawer.submiting = false;
            this.handleSearch();
            setTimeout(() => this.attendanceManagerDrawer.visible=false, 1000);
          },
          ()=>{
            this.attendanceManagerDrawer.submiting = false;
          }
        )
    },
    deleteAttendanceManager(id){
      api.ipms.AttendanceManager.remove(id)
                            .then(response=> {
                                this.$Message.success(this.$t('successText'))
                                this.handleSearch()
                            }).catch(error=> console.log(error))
    },
    handleBatchRemove(rows){
      this.batchOperate.submiting = true
      Promise.all(rows.map(item=>api.ipms.AttendanceManager.remove(item.id)))
          .then(res => {
            this.batchOperate.submiting = false;
            this.handleSearch()
          }).catch(e=> {
            this.batchOperate.submiting = false
            this.handleSearch()
          })
    }
  },
  computed: {
    columns () {
      return [
          /*{key: 'id', width: 60, fixed:'left',type:'selection'},*/
          // {key: 'userId', align:'left',minWidth: 120,fixed:'left', title:  this.$t('ipms.attendance-manager.userId.label')},
          {key: 'nickName', align:'center',minWidth: 120, title:  this.$t('ipms.attendance-manager.nackname.label')},
          // {key: 'attendanceGroup', align:'left',minWidth: 120, title:  this.$t('ipms.attendance-manager.attendanceGroup.label')},
          {
            key: 'attendanceGroup', 
            align: 'center', 
            width: 120, 

            column:'attendanceGroup',
            filters: this.$t('ipms.attendance-manager.attendanceGroup.dictionary'),
            filterMultiple: false,
            
            filterRemote:(value,row)=>{
              this.query.attendanceGroup = value
              this.handleSearch();
            },
            title: this.$t('ipms.attendance-manager.attendanceGroup.label'),
            render: (h, params) => {
              return <div>{params.column.filters.find(t => params.row.attendanceGroup==t.value).label}</div>
            }
          },
          {key: 'remark', align:'center',minWidth: 120, title:  this.$t('ipms.attendance-manager.remark.label')},
          {key: 'createTime', align: 'center', width:200, title: this.$t('ipms.attendance-manager.createTime.label'),},
          {key: 'updateTime', align: 'center', width:200, title: this.$t('ipms.attendance-manager.updateTime.label'),},
        {
          title: this.$t('operateText'),
          align: 'center',
          width: 160,
          fixed:"right",
          key: 'handle',
          render: (h, params)=>{
            return <div style="display: flex;justify-content: space-around;">
              <a href="javascript:void(0);" onClick={()=>this.openAttendanceManagerDrawer({ id: params.row.id ,type:'detail'})}>{this.$t('detailText')}</a>
              <a href="javascript:void(0);" onClick={()=>this.openAttendanceManagerDrawer({ id: params.row.id ,type:'edit' })}>{this.$t('editText')}</a>
              <Poptip confirm={true} title={this.$t('deletePopTip')} transfer={true} onOn-ok={()=>this.deleteAttendanceManager(params.row.id)}>
                <a href="javascript:void(0);">{this.$t('deleteText')}</a>
              </Poptip>
            </div>
          }
        }
      ]
    }
  }
}
</script>
